import React from "react";
import { Helmet } from "react-helmet";
import AtWork from "../components/home/AtWork";
import WhyUs from "../components/home/WhyUs";
import GreatHabibResults from "../components/reusables/GreatHabibResults";
import PageHero from "../components/reusables/hero/PageHero";
import ServicesBody from "../components/services/ServicesBody";

export default function Services() {
  return (
    <>
      <Helmet>
        <link rel="conanical" href="https://www.ghk9academy.com/our-services" />
        <meta name="description" content="Your Home of Trained Dogs" />
        <meta property="og:description" content="Your Home of Trained Dogs" />
        <meta
          property="og:title"
          content="Our Services - Great Habib K9 Academy"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1703154000/banner_i6dkvh.jpg"
        />

        <meta
          name="twitter:title"
          content="Our Services - Great Habib K9 Academy"
        />
        <meta
          name="twitter:text:title"
          content="Our Services - Great Habib K9 Academy"
        />
        <meta name="twitter:description" content="Your Home of Trained Dogs" />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1703154000/banner_i6dkvh.jpg"
        />
        <title>Our Services - Great Habib K9 Academy</title>
      </Helmet>
      <PageHero
        classes="doggy-bg"
        titleClasses="title uppercase yellow"
        title="Our Services"
      />
      <ServicesBody />
      <WhyUs />
      <AtWork />
      <GreatHabibResults />
    </>
  );
}
